import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Statistics } from './components';

import { NavBar } from '@/components';
import useTourney from '@/hooks/useTourney';
import ROUTES from '@/router/routes';

export const ViewStatistics: React.FC = React.memo(() => {
  const navigate = useNavigate();
  const { tourneyData } = useTourney();

  return (
    <NavBar
      mobile={{
        leftContent: {
          backAction: () => {
            navigate(ROUTES.viewTourney);
          },
        },
        centerContent: {
          title: 'Estadísticas',
        },
      }}
    >
      {!tourneyData.records && !tourneyData.statitics ? (
        <p className="p-4">No hay estadísticas disponibles</p>
      ) : (
        <Statistics.MobileWrapper
          dataRecords={tourneyData.records}
          dataStatitics={tourneyData.statitics}
        />
      )}
    </NavBar>
  );
});

ViewStatistics.displayName = 'ViewStatistics';
